import React/* , { useEffect } */ from 'react';
import { Grid, Paper } from '@material-ui/core';
import { CustomToast } from '@jumbo/components/custom/Toast';

import PlaceHolderComponent from './FormFichaComponents/PlaceHolderComponent';
//import SharedTitle from './SharedForms/SharedTitle';
//import GuardarYSalirBtn from './SharedForms/GuardarYSalirBtn';

const EquipamientoForm = props => {

  /*   const {setIsLoading} = props
  
    useEffect(() => {
  
      setIsLoading(false);
      //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

  return (
    <>
      <Paper style={{ width: '100%', borderTop: '5px solid #1391ad', padding: 15, flexBasis:'100%' }} elevation={1}>

{/*                             <SharedTitle
                        title={titulo}
                    />
                    <Grid item xs={12} sm={12} md={12} style={{ paddingTop: 15, paddingBottom:15 }}>
                        <p>{descripcion}</p>
                    </Grid> */}
        <Grid item xs={12} >{/*se agrego este grid y el div ademas de comentar el useeffect*/}
          <div>

            <Grid container justifyContent="center" direction="column" alignItems="center" style={{}}>
              <CustomToast />
              <PlaceHolderComponent />
              <PlaceHolderComponent />
              <PlaceHolderComponent />
              <PlaceHolderComponent />
              <PlaceHolderComponent />
            </Grid>
          </div>
        </Grid>

      </Paper>
      {/*<GuardarYSalirBtn />*/}
    </>
  );
};

export default EquipamientoForm;
